import { Injectable } from '@angular/core';
import { map, catchError, retry } from 'rxjs/operators';
import { Observable, throwError, timer } from 'rxjs';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';

@Injectable()
export class AdminService {
  constructor(private _http: HttpClient) {}

  //Add to leads mailing list in mailchimp
  //   addToMailingList() {
  //     var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));
  //     this.customer = JSON.parse(localStorage.getItem('customerInfo'));
  //     let headers = new HttpHeaders({
  //       'content-type': 'application/json',
  //       'Authorization': "Bearer " + lbriToken.token
  //     });

  //     let options = {
  //       headers: headers
  //     };

  //     let _body = {
  //       "Email": this.customer.Email
  //     }

  //     return this._http.post(this.mailingListUrl, _body, options)
  //       .pipe();
  //   }
  googleTranslate(model: any) {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
        
    return this._http
      .post(
        'https://translation.googleapis.com/language/translate/v2?key=AIzaSyBoBpekUlq0prIjdkrDPiMRT47vkzy2t58',
        model
      )
      .pipe(
        retry({
                        count: MAX_RETRIES,
                        delay: (error: HttpErrorResponse, retryCount: number) => {
                            // Retry only on transient failures
                            const status = error.status;
        
                            const isTransient =
                                status === 0 ||                 // network / CORS / DNS / offline
                                status === 429 ||               // rate limit
                                (status >= 500 && status < 600); // server errors
        
                            if (!isTransient) {
                                return throwError(() => error);
                            }
        
                            // exponential backoff with cap
                            const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                            return timer(backoff);
                        }
                    }),
      );

    // .subscribe((response:any) => {
    //     this.translatedText = response.data.translations[0].translatedText;
    // });
  }
  //Add to leads mailing list in ziplingo
  // addToMailingListZipLingo() {
  //   var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));
  //   this.customer = JSON.parse(localStorage.getItem('customerInfo'));
  //   let headers = new HttpHeaders({
  //     'content-type': 'application/json',
  //     'Authorization': "Bearer " + lbriToken.token
  //   });

  //   let options = {
  //     headers: headers
  //   };

  //   let _body = {
  //     "Email": this.customer.Email
  //   }

  //   return this._http.post(this.mailingListUrl2, _body, options)
  //     .pipe();
  // }
  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
